import { useEffect } from 'react';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import useApiHook from "./useApiHook";
import {useAuth} from "../store/auth-context";

const usePushNotifications = () => {
    const { makeRequest } = useApiHook();
    const { token: authToken, isLoading } = useAuth();

    useEffect(() => {
        if (Capacitor.getPlatform() === 'web') return;

        const initPush = async () => {

            PushNotifications.addListener('registration', async (pushToken) => {
                // Se utente loggato → salvalo subito
                if (authToken) {
                    await makeRequest('/user/push-token', 'post', {
                        token: pushToken.value,
                        platform: Capacitor.getPlatform()
                    });
                }

                // salva localmente per dopo
                localStorage.setItem("pushToken", pushToken.value);
            });

            PushNotifications.addListener('registrationError', err => {
                console.error('❌ Registration error:', err);
            });

            let permStatus = await PushNotifications.checkPermissions();

            if (permStatus.receive === 'prompt') {
                permStatus = await PushNotifications.requestPermissions();
            }

            if (permStatus.receive !== 'granted') return;

            await PushNotifications.register();
        };

        initPush();

    }, []); // 🔴 SOLO UNA VOLTA

    useEffect(() => {
        if (isLoading) return;
        if (!authToken) return;

        const savedPushToken = localStorage.getItem("pushToken");
        if (!savedPushToken) return;

        makeRequest('/user/push-token', 'post', {
            token: savedPushToken,
            platform: Capacitor.getPlatform()
        });

    }, [authToken, isLoading]);
};

export default usePushNotifications;
